import React from 'react';
import {useTranslation} from 'react-i18next';

import Form from 'components/common/Form';
import Select from 'components/common/Form/Select';
import Input from 'components/common/Form/Input';
import Button, {ButtonStyles} from 'components/common/Form/Button';

import {
    TranslateCompanySizes,
    TranslateIndustries,
    TranslateCompanyDivisions,
    TranslateCompanyPositions,
    TranslateRevenues,
} from 'constants/BusinessInformation';
import {TRANSLATE_COMPANY_TYPES} from 'constants/CompanyTypes';
import Currencies from 'constants/Finances';

import {convertToOptions, convertToValue} from 'helpers/SelectUtils';

import style from 'components/Welcome/Form/Form.module.scss';

const BusinessForm = ({data, errors, onPreviousStep, isLastStep, onNextStep, onChange}) => {
    const {t} = useTranslation();

    return (
        <div className={style.profileFormContainer}>
            <Form>
                <div className={style.inlineFieldsContainer}>
                    <Input
                        label={t('welcome:text.companyName')}
                        placeholder={t('welcome:text.companyName')}
                        name='companyName'
                        value={data.companyName}
                        error={t(errors.companyName)}
                        onChangeField={onChange}
                        customTooltipText={t('tooltips:company')}
                    />
                    <Select
                        label={t('welcome:text.type')}
                        placeholder={t('welcome:text.type')}
                        name='companyType'
                        value={convertToValue(data.companyType, TRANSLATE_COMPANY_TYPES(t))}
                        error={t(errors.companyType)}
                        options={convertToOptions(TRANSLATE_COMPANY_TYPES(t))}
                        onChangeField={onChange}
                        customTooltipText={t('tooltips:companyType')}
                    />
                </div>
                <div className={style.inlineFieldsContainer}>
                    <Select
                        label={t('welcome:text.industry')}
                        placeholder={t('welcome:text.industry')}
                        name='industry'
                        value={convertToValue(data.industry, TranslateIndustries(t))}
                        error={t(errors.industry)}
                        options={convertToOptions(TranslateIndustries(t))}
                        onChangeField={onChange}
                        className={style.select}
                        customTooltipText={t('tooltips:industry')}
                    />
                    <Select
                        label={t('welcome:text.size')}
                        placeholder={t('welcome:text.size')}
                        name='companyResponsibilities'
                        value={convertToValue(data.companyResponsibilities, TranslateCompanySizes(t))}
                        error={t(errors.companyResponsibilities)}
                        options={convertToOptions(TranslateCompanySizes(t))}
                        onChangeField={onChange}
                        className={style.select}
                        customTooltipText={t('tooltips:size')}
                    />
                </div>
                <div className={style.inlineFieldsContainer}>
                    <Input
                        label={t('welcome:text.companyAddress')}
                        placeholder={t('welcome:text.companyAddress')}
                        name='companyAddress'
                        value={data.companyAddress}
                        error={t(errors.companyAddress)}
                        onChangeField={onChange}
                        customTooltipText={t('tooltips:companyAddress')}
                    />
                </div>
                <div className={style.inlineFieldsContainer}>
                    <Select
                        label={t('welcome:text.revenue')}
                        placeholder={t('welcome:text.revenue')}
                        name='revenue'
                        value={convertToValue(data.revenue, TranslateRevenues(t))}
                        options={convertToOptions(TranslateRevenues(t))}
                        error={t(errors.revenue)}
                        onChangeField={onChange}
                        customTooltipText={t('tooltips:revenue')}
                        className={style.select}
                    />
                    <Select
                        label={t('welcome:text.currencyPlaceholder')}
                        placeholder={t('welcome:text.currencyPlaceholder')}
                        name='currency'
                        value={convertToValue(data.currency, Currencies)}
                        error={t(errors.currency)}
                        options={convertToOptions(Currencies)}
                        onChangeField={onChange}
                        className={style.select}
                        customTooltipText={t('tooltips:currency')}
                    />
                </div>
                <div className={style.inlineFieldsContainer}>
                    <Select
                        label={t('welcome:text.companyPosition')}
                        placeholder={t('welcome:text.companyPosition')}
                        name='companyPosition'
                        value={convertToValue(data.companyPosition, TranslateCompanyPositions(t))}
                        error={t(errors.companyPosition)}
                        options={convertToOptions(TranslateCompanyPositions(t))}
                        onChangeField={onChange}
                        className={style.select}
                        customTooltipText={t('tooltips:position')}
                    />
                    <Select
                        label={t('welcome:text.division')}
                        placeholder={t('welcome:text.division')}
                        name='companyDivision'
                        value={convertToValue(data.companyDivision, TranslateCompanyDivisions(t))}
                        error={t(errors.companyDivision)}
                        options={convertToOptions(TranslateCompanyDivisions(t))}
                        onChangeField={onChange}
                        className={style.select}
                        customTooltipText={t('tooltips:sector')}
                    />
                </div>
                {isLastStep && <div className={style.commonError}>{errors.common}</div>}
                <Button text={t('welcome:buttons.back')} onClick={onPreviousStep} />
                <Button
                    text={isLastStep ? t('welcome:buttons.getStarted') : t('welcome:buttons.continue')}
                    onClick={() => onNextStep(isLastStep)}
                    btnStyle={ButtonStyles.primary}
                />
            </Form>
        </div>
    );
};

export default BusinessForm;
